module.exports = __webpack_public_path__ + "img/lv4.81dc7dc8.png";